import { EventCreatorMap } from '@app/analytics/models/helpers';

import productAddToCart from './add-to-cart';
import productLike from './like';
import productAlert from './alert';
import productPriceAlert from './price-drop-alert';
import productAddToWishlist from './add-to-wishlist';
import productRemoveToWishlist from './remove-from-wishlist';
import clickConsigmentCTA from './consignment';
import productCrossSellClick from './cross-sell-click';
import clickProductFeed from './product-feed-click';
import CreateHolidaysEndAlertSuccess from './createHolidaysEndAlert';
import DeleteHolidaysEndAlertSuccess from './deleteHolidaysEndAlert';
import productModuleScrollPDP from './product-module-scroll';
import productModuleDisplay from './product-module-display';

import * as ProductActions from '@app/+product/store/actions/product.action';
import { CartActionTypes } from '@app/core/cart/actions/cart.actions';
import { TRACK_PRODUCT_FEED_CLICK } from '@app/+catalog/store';

const eventsMap: EventCreatorMap = {
  [CartActionTypes.AddToCartSuccess]: productAddToCart,
  [ProductActions.ProductActionTypes.LikeSuccess]: productLike,
  [ProductActions.ProductActionTypes.CreateAlertSuccess]: productAlert,
  [ProductActions.ProductActionTypes.CreateHolidaysEndAlertSuccess]: CreateHolidaysEndAlertSuccess,
  [ProductActions.ProductActionTypes.DeleteHolidaysEndAlertSuccess]: DeleteHolidaysEndAlertSuccess,
  [ProductActions.ProductActionTypes.CreatePriceAlertSuccess]: productPriceAlert,
  [ProductActions.ProductActionTypes.AddToWishlistSuccess]: productAddToWishlist,
  [ProductActions.ProductActionTypes.RemoveToWishlistSuccess]: productRemoveToWishlist,
  [ProductActions.ProductActionTypes.ClickConsigmentCTA]: clickConsigmentCTA,
  [ProductActions.ProductActionTypes.ProductModuleScroll]: productModuleScrollPDP,
  [ProductActions.ProductActionTypes.ProductCrossSellClick]: productCrossSellClick,
  [ProductActions.ProductActionTypes.ProductModuleDisplay]: productModuleDisplay,
  [TRACK_PRODUCT_FEED_CLICK]: clickProductFeed
};

export default eventsMap;
